<template>
  <div>
    <div class="form-group">
      <label>
        <input type="checkbox" v-model="order.use_shipping_as_billing" />
        Use shipping address as billing address
      </label>
    </div>

    <template v-if="showBillingAddress">
      <div class="form-group">
        <label>
          <input type="checkbox" v-model="isCountryOutsideUS" />
          Billing address is outside of the US?
        </label>
      </div>

      <div v-if="isCountryOutsideUS" class="form-group">
        <label for="billing_country">Country</label>
        <select class="form-control" v-model="order.billing.country_code_alpha2" id="billing_country">
          <option v-for="country in countries" :key="country[1]" :value="country[1]">
            {{ country[0] }} / {{ country[1] }}
          </option>
        </select>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="billing_first_name">First Name</label>
            <input type="text" class="form-control" v-model="order.billing.first_name" id="billing_first_name" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="billing_last_name">Last Name</label>
            <input type="text" class="form-control" v-model="order.billing.last_name" id="billing_last_name" />
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="billing_street">Street</label>
        <input type="text" class="form-control" v-model="order.billing.street" id="billing_street" />
      </div>
      <div class="form-group">
        <label for="billing_number">Number/APT/UNIT/SUITE(optional)</label>
        <input type="text" class="form-control" v-model="order.billing.number" id="billing_number" />
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="billing_city">City</label>
            <input type="text" class="form-control" v-model="order.billing.city" id="billing_city" />
          </div>
        </div>
        <div class="col-sm-6">
          <div v-if="order.billing.country_code_alpha2 == 'US'" class="form-group">
            <label for="billing_state">State</label>
            <select class="form-control" v-model="order.billing.state" id="billing_state">
              <option v-for="state in states" :key="state[1]" :value="state[1]">
                {{ state[0] }} / {{ state[1] }}
              </option>
            </select>
          </div>

          <div v-else class="form-group">
            <label for="billing_state">State/Province</label>
            <input type="text" class="form-control" v-model="order.billing.state" id="billing_state" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="billing_zip">Zip Code</label>
            <input type="text" class="form-control" v-model="order.billing.zip" id="billing_zip" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import { isEmpty, debounce } from 'lodash';
import * as Toastr from "toastr";

import { states, countries } from "../../../../../data/checkoutData.js";

export default {
  name: 'AppCheckoutManualOrder',
  props: {
    order: {
      type: Object,
      required: true
    },
    updatePath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      states: states,
      countries: countries,
      isCountryOutsideUS: false,
    }
  },
  watch: {
    'order.use_shipping_as_billing'(newValue) {
      this.updateOrder();
      console.log("triggered use_shipping_as_billing watcher", newValue);
    },
    'order.billing.first_name': {
      handler: debounce(function(newValue) {
        this.updateOrder();
      }, 500)
    },
    'order.billing.last_name': {
      handler: debounce(function(newValue) {
        this.updateOrder();
      }, 500)
    },
    'order.billing.street': {
      handler: debounce(function(newValue) {
        this.updateOrder();
      }, 500)
    },
    'order.billing.number': {
      handler: debounce(function(newValue) {
        this.updateOrder();
      }, 500)
    },
    'order.billing.city': {
      handler: debounce(function(newValue) {
        this.updateOrder();
      }, 500)
    },
    'order.billing.state': {
      handler: debounce(function(newValue) {
        this.updateOrder();
      }, 500)
    },
    'order.billing.zip': {
      handler: debounce(function(newValue) {
        this.updateOrder();
      }, 500)
    },
    'order.billing.country_code_alpha2': {
      handler: function(newValue) {
        this.isCountryOutsideUS = newValue !== 'US';
        this.updateOrder();
      }
    }
  },
  computed: {
    showBillingAddress() {
      return !this.order.use_shipping_as_billing;
    }
  },
  mounted() {
    // Initialize the isCountryOutsideUS based on the initial billing country
    this.isCountryOutsideUS = this.order.billing.country_code_alpha2 !== 'US';
  },
  methods: {
    updateOrder() {
      if (this.order.use_shipping_as_billing) {
        this.order.billing = Object.assign({}, this.order.shipping);
      }

      $.ajax({
        method: "PUT",
        url: this.updatePath,
        data: { order: this.order },
        success: (data) => {
          this.$emit('orderUpdated', data);
          // console.log("Order updated successfully");
        },
        error: (error) => {
          console.error("Error updating order:", error);

          if (!isEmpty(response.responseJSON)) {
            if (response.responseJSON.errors) {
              response.responseJSON.errors.forEach((error) => {
                const attribute = error.source ? error.source.pointer.split("/").slice(-1)[0] : ''
                Toastr.error(error.detail, 'Error ' + attribute);
              })
            }
          } else {
            Toastr.error('Error while updating order', 'Error')
          }
        }
      });
    }
  }
}
</script>
